import React from 'react';

import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import MDEditor from '@uiw/react-md-editor';

import { LastModifiedDatetime } from '../../service/entity/valueObjects/lastModifiedDatetime';

import type { ContentJson } from '@/types/domain/privateBlog/entities/contentEntity';
import type { PrivateBlogJson } from '@/types/domain/privateBlog/entities/privateBlogEntity';

const Content: React.FC<{
  /** データ */
  data: {
    /** コンテンツ */
    content: ContentJson,
    /** ページ */
    privateBlog: PrivateBlogJson,
    /** date */
    publishDate: string,
  },
}> = ({ data }) => {
  const date = LastModifiedDatetime.create(new Date(data.publishDate));
  return (
    <>
      <List component="div" disablePadding>
        <ListItem>
          <ListItemText
            primary={data.privateBlog.title}
            secondary={`${date.toStringDateDisplay()}`}
            primaryTypographyProps={{
              fontWeight: '1000',
              variant: 'h6',
            }}
          />
        </ListItem>
      </List>
      <Divider style={{ marginBottom: '20px' }} />
      <Box sx={{ marginLeft: '20px' }}>
        <div className="container">
          <MDEditor.Markdown
            source={data.content.text}
            components={{
              img: (e) => {
                if (e.src) {
                  const index = parseInt(e.src, 10);
                  if (!Number.isNaN(index) && index >= 0 && index < data.content.images.length) {
                    return <img alt={e.alt} src={data.content.images[index]} />;
                  }
                }
                return <img alt={e.alt} src={e.src} />;
              },
            }}
          />
        </div>
      </Box>
      {data.content.attachments.length > 0 && (
        <>
          <Divider style={{ marginBottom: '10px' }} />
          <div>
            <p>
              <span>添付ファイル：</span>
              <a
                download={data.content.attachments[0].name}
                href={data.content.attachments[0].content}
              >
                {data.content.attachments[0].name}
              </a>
            </p>
          </div>
        </>
      )}
    </>
  );
};

export default Content;
